<div class="" id="Loading" [style]="{'display': this.payload?.isLoading ? 'flex' : 'none'}">
    <div class="Text">
        {{this.payload?.message}} <i class="fas fa-spinner fa-spin"></i>
    </div>
</div>